<template>
  <div class="scroll-horizontal-section-block" ref="block">
    <div class="scroll-horizontal-section__timeline-ball" />
    <div class="scroll-horizontal-section-block__content">
      <!-- Center Image block -->
      <div
        v-if="props.content.topLeftImage"
        class="scroll-horizontal-section-block__top-left-image"
      >
        <div class="" data-animate="block-image">
          <WidgetPicture
            :image="props.content.topLeftImage"
            :lazyLoad="true"
            :alt="props.content.year"
          />
        </div>
      </div>

      <!-- Top Left Image block -->
      <div
        v-if="false && props.content.topLeftImage"
        data-animate="block-image"
        class="scroll-horizontal-section-block__top-left-image"
      >
        <WidgetPicture
          :image="props.content.topLeftImage"
          :lazyLoad="true"
          :alt="props.content.year"
        />
        <div
          v-if="props.content.topLeftImageText"
          class="text m-top-8px hide-for-small"
          v-html="props.content.topLeftImageText"
        />
      </div>

      <!-- Right Image block -->
      <div
        v-if="props.content.rightImage"
        data-animate="block-image"
        class="scroll-horizontal-section-block__right-image"
      >
        <WidgetPicture
          :image="props.content.rightImage"
          :lazyLoad="true"
          :alt="props.content.year"
        />
        <div
          v-if="props.content.rightImageText"
          class="text m-top-8px hide-for-small"
          v-html="props.content.rightImageText"
        />
      </div>

      <!-- Bottom Left Image block -->
      <div
        v-if="props.content.bottomLeftImage"
        data-animate="block-image"
        class="scroll-horizontal-section-block__bottom-left-image"
      >
        <WidgetPicture
          :image="props.content.bottomLeftImage"
          :lazyLoad="true"
          :alt="props.content.year"
        />
      </div>

      <!-- Side Image block -->
      <div
        v-if="props.content.sideImage"
        data-animate="block-image"
        class="scroll-horizontal-section-block__side-image"
        :class="{'--is-down': props.content.sideImageDown}"
      >
        <WidgetPicture
          :image="props.content.sideImage"
          :lazyLoad="true"
          :alt="props.content.year"
        />
      </div>

      <!-- Left Png -->
      <div
        v-if="props.content.leftPng"
        data-animate="block-image"
        class="scroll-horizontal-section-block__left-png"
      >
        <WidgetPicture
          :image="props.content.leftPng"
          :lazyLoad="true"
          :alt="props.content.year"
        />
      </div>

      <!-- Right Png -->
      <div
        v-if="props.content.rightPng"
        data-animate="block-image"
        class="scroll-horizontal-section-block__right-png"
      >
        <WidgetPicture
          :image="props.content.rightPng"
          :lazyLoad="true"
          :alt="props.content.year"
        />
      </div>

      <!-- Year block -->
      <div
        v-if="props.content.year"
        class="scroll-horizontal-section-block__year"
      >
        <div class="title-xxl">
          <h3 data-animate="block-text">{{ props.content.year }}</h3>
        </div>
      </div>

      <!-- Description text block -->
      <div
        v-if="props.content.description"
        class="scroll-horizontal-section-block__description text"
      >
        <div>
          <div data-animate="block-text" v-html="props.content.description" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WidgetScrollHorizontalSectionBlock',
}
</script>

<script setup>
import { gsap } from 'gsap'

const props = defineProps({
  show: Boolean,
  content: Object,
  index: Number,
})

const block = ref(null)

const tl = ref(null)

watch(
  () => props.show,
  (show) => {
    if (!tl.value?.isActive()) {
      tl.value = show ? animateIn() : animateOut()
      tl.value.play()
    }
  }
)

// Animazioni
const animateIn = (params) => {
  const parent = block.value
  const textBlocks = parent.querySelectorAll('[data-animate="block-text"]')
  const imageBlocks = parent.querySelectorAll(
    '[data-animate="block-text"], [data-animate="block-image"]'
  )

  const tl = gsap.timeline({
    paused: true,
    onComplete: () => {
      tl.kill()
    },
    ...params,
  })
  tl.set(parent, { autoAlpha: 1 })
  tl.add('showHorizontalBlocks')
  tl.to(
    textBlocks,
    {
      y: '0%',
      stagger: 0.2,
      opacity: 1,
    },
    'showHorizontalBlocks'
  )
  tl.to(
    imageBlocks,
    {
      y: '0%',
      stagger: 0.2,
      opacity: 1,
    },
    'showHorizontalBlocks'
  )

  return tl
}

const animateOut = (params) => {
  const parent = block.value
  const blocks = parent.querySelectorAll(
    '[data-animate="block-text"], [data-animate="block-image"]'
  )

  const tl = gsap.timeline({
    paused: true,
    onComplete: () => {
      tl.kill()
      gsap.set([parent, blocks], {
        clearProps: 'all',
      })
    },
    ...params,
  })
  tl.to(blocks, {
    y: '101%',
    opacity: 0,
  })
  tl.set(parent, { autoAlpha: 0 })

  return tl
}

defineExpose({
  animateIn,
  animateOut,
})
</script>

<style lang="scss">
@import './style.scss';
</style>
